import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Link as RouterLink, useLocation } from 'react-router-dom';

import { crumbsFor } from './nav';

/**
 * The way back out of a screen you reached by id.
 *
 * The sidebar gets you into a section; this gets you back up from a review or a job,
 * which have no menu entry because they are one row rather than a destination. Without
 * it the only way out of `/authoring/lessons/:id` is the browser's back button.
 *
 * The trail is derived from the path rather than passed in by each screen — `nav.ts` says
 * why. Nothing renders when a path has no trail, so the root keeps its own heading rather
 * than growing a breadcrumb that points at itself.
 */
export function Crumbs() {
  const { pathname } = useLocation();
  const trail = crumbsFor(pathname);

  if (trail.length === 0) return null;

  return (
    <Breadcrumbs aria-label="breadcrumb">
      {trail.map((crumb) =>
        crumb.to === undefined ? (
          <Typography key={crumb.label} color="text.primary">
            {crumb.label}
          </Typography>
        ) : (
          <Link
            key={crumb.label}
            component={RouterLink}
            to={crumb.to}
            underline="hover"
            color="inherit"
          >
            {crumb.label}
          </Link>
        ),
      )}
    </Breadcrumbs>
  );
}
